module.exports = __webpack_public_path__ + "assets/img/component_tree.2c6ed106.jpg";